import {
    checkDigitsCount,
    yearsBeforeNow,
    makeMoment,
    // nowAddMonths
} from "@/helpers/helpers";

// Правила получения очищенных значений полей
const cleanRules = {
    phone(str) {
        return str.replace('+7', '').replace(/\s+/g, '');
    },
    phoneWithSeven(str) {
        return str.replace('+', '').replace(/\s+/g, '');
    },
    passport(str) {
        return str.replace(/\s+/g, '').match(/^[0-9]{4,4}/g)[0] + ' ' + str.replace(/\s+/g, '').split(/^[0-9]{0,4}/g)[1]
    },
    getDigits(str) {
        return str.replace(/\D/g, '');
    },
    withoutSpace(str) {
        return str.replace(/\s+/g, '');
    }
};

const validationRules = {
    required: value => !!value || 'Заполните',
    requiredAutocomplete: (value) => !!value || 'Выберите из списка',
    fullFio: (value) => {
        return value.split(' ').length >= 2 || 'Введите полное ФИО'
    },
    // fio: (value) => {
    //     return value.split(' ').length >= 2 || 'Введите фамилию и имя'
    // },
    passport: (value) =>
        checkDigitsCount(value, 10) ||
        'Серия номер паспорта введены не полностью',
    email:
        (
            value,
            pattern = /^(([^а-яА-ЯёЁ<>()[\]\\.,;:\s@"]+(\.[^а-яА-ЯёЁ<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) =>
            pattern.test(value) || 'Введите корректный e-mail',
    phoneFirstDigitIs9:
        (
            value,
            pattern = /^(\+7 9)./
        ) =>
            pattern.test(value) || 'Номер должен начинаться с 9',
    phone: value => checkDigitsCount(value, 11) || 'Номер введен не полностью',
    code: value => checkDigitsCount(value, 5) || 'СМС код введен не полностью',
    date: value => checkDigitsCount(value, 8) || `Дата введена не полностью`,
    sms: value => checkDigitsCount(value, 4) || 'Введите код из sms',
    taxCode: value => checkDigitsCount(value, 6) || 'Введите адрес полностью',
    correctDate: value =>
        makeMoment(value).isValid() || 'Дата введена некорректно',
    divisionCode: (value) =>
        checkDigitsCount(value, 6) || 'Код подразделения введен не полностью',
    birthdate: {
        min: yearsBeforeNow(70),
        max: yearsBeforeNow(18),
        limitations: value => {
            let date = makeMoment(value);

            return (date.isValid()
                    && date > validationRules.birthdate.min
                    && date < validationRules.birthdate.max)
                || 'Допустим возраст от 18 до 70 лет'
        },
    },
    inn: value => checkDigitsCount(value, 10) || 'ИНН введен не полностью',
};

// Алиасы
const CR = cleanRules;
const VR = validationRules;

export default {
    mounted() {
        // this.anketa.term.updateLabel();
    },
    methods: {
        getState() {
            const anketa = this.$anketa;
            let state = {};

            Object.keys(anketa).forEach(
                name => {
                    anketa[name]?.value !== undefined
                        ? state[name] = anketa[name].value
                        : state[name] = anketa[name];
                }
            )

            return JSON.stringify(state);
        },
        setState(data) {
            const state = JSON.parse(data);
            if (!state) return;

            const anketa = this.$anketa;
            let names = Object.keys(state);

            if (names.length > 0) {
                names.forEach(
                    name => anketa[name]?.value !== undefined
                        ? anketa[name].value = state[name]
                        : anketa[name] = state[name]
                );
            }
        },
    },
    data() {
        return {
            anketa: {
                onlineToken:'', // бывший anketId

                // переименовать в sumGoods
                initialPayment: { // это не ПВ
                    value: 5000,
                    label: "Сумма, ₽",
                    fieldType: "slider",
                    // grid: {
                    //     cols: 12,
                    //     sm: 10
                    // },
                    type: "tel",
                    min: 1000,
                    max: 30000,
                    step: 500,
                    input() {
                        // console.log('initialPayment.input');
                        // this.updateLabel();
                    },
                    // initialize(sumGoods) {
                    //     if (!sumGoods) {
                    //         sumGoods = this.max * 2;
                    //     }

                    //     this.min = 0;
                    //     this.max = Math.round(sumGoods * 50) / 100;
                    //     this.value = Math.round(sumGoods * 25) / 100;
                    //     this.percent = 25;
                    //     this.step = sumGoods / 40;
                    //     // Делаем шаги по 5%
                    //     this.ticks = [...Array(11).keys()].map(step => step * (sumGoods * 0.05));
                    // },
                    // updateLabel() {
                    //     const percent = Math.round(this.value / this.max * 50);
                    //     this.label = `Первоначальный взнос ${percent}%`;
                    //     this.percent = percent;
                    // },
                    percent: 0,
                },
                term: {
                    label: "Срок, дней",
                    fieldType: "slider",
                    type: "tel",
                    percent: 12,
                    value: 3,
                    min: 1,
                    max: 30,
                    step: 1,
                    // ticks: [3, 5, 12],
                    // grid: {
                    //     cols: 12,
                    //     sm: 10
                    // },
                    input() {
                        // this.updateLabel();
                    },
                    initialize(rates) {
                        this.ticks = rates.map(rate => rate.period);
                        this.value = Math.min(...this.ticks);
                    },
                    // updateLabel() {
                    //     const date = nowAddMonths(this.value);
                    //     this.label = `Последний платеж ${date}`;
                    // },

                },
                phone: {
                    value: '',
                    mask: '+7 ### ### ## ##',
                    placeholder: 'Номер телефона',
                    cleanValue() {
                        return cleanRules.phone(this.value);
                    },
                    valueWithSeven() {
                        return CR.phoneWithSeven(this.value);
                    },
                    grid: {
                        cols: 12,
                        sm: 6
                    },
                    focus: () => {
                        let field = this.anketa.phone;

                        if (field.value == '') {
                            field.value = '+7 ';
                        }
                    },
                    input() {
                    },
                    rules: [
                        VR.required,
                        VR.phoneFirstDigitIs9,
                        VR.phone,
                    ],
                    type: "tel",
                },
                
                fio: {
                    value: '',
                    fieldType: 'autocomplete',
                    items: [],
                    grid: {
                        cols: 12,
                    },
                    input() {
                    },
                    placeholder: 'ФИО',
                    rules: [
                        // VR.requiredAutocomplete,
                        // val => this.$anketa.fio.items.some(item => item.value == val)
                        //     || 'Выберите из списка',
                        VR.fullFio
                    ],
                    search: (value) => {
                        // const patronymicMissing = this.anketa.patronymicMissing.value;

                        this.connector.dadata.fio(value).then(
                            data => {
                                let suggestions = data.FIO
                                    .filter((item) => item.lastName)
                                    .map((item) => ({
                                        value: [
                                            item.lastName,
                                            item.firstName,
                                            item.middleName,
                                            ]
                                            .join(' ')
                                            .trim(),
                                        gender: item.gender == 'MALE'
                                    }));
                                this.anketa.fio.items = [{value}, ...suggestions];
                                this.anketa.gender.value = suggestions.filter(s=>s.value == value)[0].gender;
                            });
                    },
                    setValue(value) {
                        this.items = [{value}];
                        this.value = value;
                    },
                    cleanValue() {
                        return CR.withoutSpace(this.value);
                    },
                },
                patronymicMissing: {
                    value: false,
                    label: 'Отчество отсутствует',
                    input: (isMissing) => {
                        let fio = this.anketa.fio.value.split(' ');

                        this.anketa.fio.rules.pop();

                        if (isMissing) {
                            this.anketa.fio.rules.push(VR.fio);

                            // ФИО могло еще не заполняться или фамилия не введена
                            if (!fio[1]) {
                                return
                            }

                            this.anketa.fio.value = `${fio[0]} ${fio[1]}`;
                            this.anketa.fio.search(`${fio[0]} ${fio[1]}`);
                        } else {
                            this.anketa.fio.rules.push(VR.fullFio);
                        }
                    },
                    fieldType: "checkbox",
                },
                birthdate: {
                    value: '',
                    fieldType: 'date',
                    placeholder: 'Дата рождения',
                    max: VR.birthdate.max.format('YYYY-MM-DD'),
                    min: VR.birthdate.min.format('YYYY-MM-DD'),
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    input: () => {
                    },
                    rules: [
                        VR.required,
                        VR.date,
                        VR.correctDate,
                        VR.birthdate.limitations,
                    ],
                },
                gender: {
                    value: true,
                    fieldType:"gender",
                    placeholder: 'Пол',
                    grid: {
                        cols: 12,
                        md:6
                    },
                },
                income: {
                    value: '',
                    placeholder: 'Доход',
                    type: 'tel',
                    grid: {
                        cols: 12,
                        sm: 6,
                    },
                    isMoney: true,
                    rules: [VR.required],
                    cleanValue() {
                        return CR.getDigits(this.value);
                    },
                },
                passport: {
                    value: '',
                    cleanValue() {
                        return CR.getDigits(this.value);
                    },
                    placeholder: 'Серия и номер паспорта',
                    mask: '## ## ######',
                    type: 'tel',
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    rules: [VR.required, VR.passport],
                    isSending: false,
                    input: (value) => {
                        
                    },
                },
                birthplace: {
                    placeholder: 'Место рождения',
                    value: '',
                    grid: {
                        cols: 12,
                        // md: 6,
                    },
                    
                    rules: [VR.required],
                    // rules: [VR.requiredAutocomplete],
                    // fieldType: 'autocomplete',
                    // 'item-text': 'value',
                    // items: [],

                    // search: (val) => {
                    //     if (this.anketa.birthplace.value) {
                    //         this.anketa.birthplace.value = val;
                    //     }

                    //     this.connector.dadata.address(val).then((data) => {
                    //         this.anketa.birthplace.items = data.suggestions;
                    //     });
                    // },
                },
                registrationAddress: {
                    value: '',
                    fieldType: 'autocomplete',
                    data: null,
                    placeholder: 'Адрес регистрации',
                    items: [],
                    rules: [
                        VR.requiredAutocomplete, 
                        () => this.anketa.registrationAddress.items.length > 0 || 'Выберите адрес из списка',
                        () => VR.taxCode(this.anketa.registrationAddress.items[0]?.data?.taxCode)
                    ],
                    search: (val) => {
                        const field = this.anketa.registrationAddress;

                        if (this.anketa.isAddressesMatches.value) {
                            this.anketa.residentialAddress.value = val;
                        }

                        this.connector.dadata.address(val).then((data) => {
                            if (data.IsSuccess) {
                                field.items =
                                    data.KladrInfo.map( item => ({
                                        value: item.addressString,
                                        data: item.address
                                    }));
                                
                                field.data = field.items.filter( item => item.value == this.value )[0]?.data || null;
                            }
                        });
                    },
                    getData() {
                        this.items[0].data.AddressType = 1;

                        return this.items[0].data;
                        // return {
                        //     "AddressType": 1, // 1 - регистрация, 2 - проживание, 5 - работа
                        //     "IsKladr": true,
                        //     "Region": "Московская",
                        //     "RegionType": "обл",
                        //     "RegionCode": "50",
                        //     "District": null,
                        //     "DistrictType": null,
                        //     "DistrictCode": null,
                        //     "Town": "Химки",
                        //     "TownType": "г",
                        //     "TownCode": "030",
                        //     "Locality": null,
                        //     "LocalityType": null,
                        //     "LocalityCode": null,
                        //     "Street": "Мира",
                        //     "StreetType": "пр-кт",
                        //     "StreetCode": "0036",
                        //     "streetNum": "1",
                        //     "buildingNum": null,
                        //     "blockNum": null,
                        //     "flatNum": null,
                        //     "taxCode": "141401",
                        //     "okato": "456123"
                        // }
                    }
                },
                residentialAddress: {
                    value: '',
                    data: null,
                    placeholder: 'Адрес проживания',
                    fieldType: 'autocomplete',
                    items: [],
                    rules: [
                        VR.requiredAutocomplete,
                        () => this.anketa.residentialAddress.items.length > 0 || 'Выберите адрес из списка',
                        () => VR.taxCode(this.anketa?.residentialAddress?.items[0]?.data?.taxCode)
                    ],
                    search: (val) => {
                        const field = this.anketa.residentialAddress;

                        this.connector.dadata.address(val).then((data) => {
                            if (data.IsSuccess) {
                                field.items =
                                    data.KladrInfo.map( item => ({
                                        value: item.addressString,
                                        data: item.address
                                    }));
                                
                                field.data = field.items.filter( item => item.value == this.value )[0]?.data || null;
                            }
                        });
                    },
                    visible: false,
                    getData() {
                        this.items[0].data.AddressType = 2;

                        return this.items[0].data;
                    }
                },
                isAddressesMatches: {
                    value: true,
                    fieldType: 'checkbox',
                    label: 'Адрес фактического проживания совпадает с адресом регистрации',
                    grid: {
                    	cols: 12,
                    	// sm: 6
                    },
                    input: (checked) => {
                        if (checked) {
                            this.anketa.residentialAddress.value =
                                this.anketa.registrationAddress.value;
                        } else {
                            this.anketa.residentialAddress.value = '';
                        }
                        this.anketa.residentialAddress.visible = !checked;

                        console.log('data', this.anketa.registrationAddress.getData())
                    },
                },
                personalDataProcessing: {
                    value: true,
                    fieldType: 'checkbox',
                    label: 'Я согласен на обработку персональных данных',
                    grid: {
                    	cols: 12,
                    	// sm: 6
                    },
                    input: (checked) => {
                    },
                },
                

                email: {
                    value: '',
                    placeholder: 'E-mail',
                    cleanValue() {
                        return cleanRules.withoutSpace(this.value);
                    },
                    grid: {
                        cols: 12,
                        // sm: 8
                    },
                    input() {
                    },
                    rules: [
                        VR.required,
                        VR.email,
                    ],
                    type: "email",
                },
                password: {
                    value: '',
                    placeholder: 'Пароль',
                    grid: {
                        cols: 12,
                        sm: 8
                    },
                    input() {
                    },
                    rules: [
                        VR.required,
                    ],
                    type: "password",
                },
                codeSMS: {
                    value: '',
                    disabled: true,
                    placeholder: "Код из СМС",
                    mask: '#####',
                    success: false,
                    isChecking: false,
                    errorMessage: '',
                    seconds: 120,
                    checkTimeout: null,
                    // fieldType: 'codeSMS',
                    grid: {
                        cols: 12,
                        md: 6
                    },
                    cleanValue() {
                        return cleanRules.withoutSpace(this.value);
                    },
                    getSms: () => {
                        this.connector.SendSmsConsent()
                            .then(data => {
                                this.$anketa.codeSMS.seconds = Math.round((
                                    new Date(
                                        new Date(data.dateExpiresOn).getTime()
                                        - new Date(data.dateSent).getTime()
                                    ).getTime()
                                ) / 1000);
                            });
                    },
                    input: val => {
                        const field = this.anketa.codeSMS;

                        field.errorMessage = '';
                        if (val.length === 5 && !field.isChecking) {
                            let isCreated = false;
                            clearTimeout(this.$anketa.codeSMS.checkTimeout);

                            this.$anketa.codeSMS.checkTimeout = setTimeout(() => {
                                this.$connector.CheckSmsConsent().then(data => {
                                    if (data.codeVerified && !isCreated) {
                                        if (this.$CLObject.type !== 'bnpl') {
                                            this.$connector.create().then(
                                                response => {
                                                    if (response.applicationId) {
                                                        this.modals.close();
                                                        this.forms.open('StatusWaiting');
                                                        field.isChecking = true;
                                                        this.$anketa.applicationId = response.applicationId;
                                                    }
                                                }
                                            )
                                        } else {
                                            this.modals.close();
                                            this.$forms.open('AdditionalServices');
                                        }
                                    } else {
                                        field.errorMessage = 'Неверный код';
                                    }

                                }).catch(() => {
                                    field.errorMessage = 'Неверный код';
                                })
                            }, 350);
                        }
                    }
                },
                issueDate: {
                    value: '',
                    // forceValue: null,
                    placeholder: 'Дата выдачи',
                    fieldType: 'date',
                    grid: {
                        cols: 12,
                        md: 6
                    },
                    min: '',
                    rules: [
                        VR.required, 
                        VR.date,
                        // value => {
                        //     const min = makeMoment(this.anketa.dateIssue.min);
                        //     const date = makeMoment(value);

                        //     if (date.isValid()) {
                        //         return date.isAfter(min) 
                        //             || `Дата выдачи должна быть больше ${moment(min).format("DD.MM.YYYY")}`;
                        //     } 
                        //     else {
                        //         return '!!!';
                        //     }
                        // }
                    ],
                    
                    input: () => this.anketa.issuedBy.fill(),
                    // Устанавливается в зависимости от дня рождения
                    min: null, 
                    setRange: () => {
                        const birthdate = this.anketa.birthdate.value;
                        const age = getYears(birthdate);
                        const min = 20;
                        const max = 45;

                        // console.log('setRange', birthdate, age, min , max);
                        
                        if (age >= min && age <= max) {
                            this.anketa.dateIssue.min = 
                                moment(birthdate, "DD.MM.YYYY")
                                    .add(min, 'years')
                                    .add(-1, 'days')
                                    .format("YYYY-MM-DD");
                        } else if (age >= max) {
                            this.anketa.dateIssue.min = 
                                moment(birthdate, "DD.MM.YYYY")
                                    .add(max, 'years')
                                    .add(-1, 'days')
                                    .format("YYYY-MM-DD");
                        }
                        // console.log('dateIssue min:', this.anketa.dateIssue.min);
                    },
                    getValue() {
                        return makeMoment(this.value, "YYYY-MM-DD");
                    }
                },
                issuePlace: {
                    value: '',
                    placeholder: 'Место выдачи паспорта',
                    grid: {
                        cols: 12,
                        md: 6
                    }
                },
                issuedBy: {
                    value: '',
                    placeholder: 'Орган, выдавший паспорт',
                    grid: {
                        cols: 12,
                        // md: 6
                    },
                    rules: [VR.required],
                    fill: () => {
                        console.log('issuedBy',VR.divisionCode(this.anketa.divisionCode.value), VR.date(this.anketa.issueDate.value))
                        if (
                            VR.divisionCode(this.anketa.divisionCode.value) === true 
                            && VR.date(this.anketa.issueDate.value) === true
                        ) {
                            this.connector.dadata.passportIssuer()
                                .then(
                                    (issuer) =>
                                        (this.anketa.issuedBy.value =
                                            '' + issuer.Issuer[0])
                                );
                        }
                    },
                },
                divisionCode: {
                    value: '',
                    placeholder: 'Код подразделения',
                    mask: '###-###',
                    type: 'tel',
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    rules: [VR.required, VR.divisionCode],
                    input: () => this.anketa.issuedBy.fill(),
                    cleanValue() {
                        return this.value.replace( /\D/g, '');
                    }
                },
                maritalStatus: {
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    placeholder: 'Семейное положение',
                    fieldType: 'select',
                    list: [
                        { id:'1', text:'Холост/не замужем'},
                        { id:'2', text:'Женат/замужем'},
                        { id:'3', text:'Вдовец/вдова'},
                        { id:'4', text:'Разведен (а)'},
                        { id:'5', text:'Гражданский брак'}
                        // 'Женат/замужем',
                        // 'Холост/не замужем',
                        // 'В разводе',
                        // 'Вдовец/вдова',
                        // 'Гражданский брак',
                    ],
                    rules: [VR.required],
                },
                childsCount: {
                    value: '',
                    placeholder: 'Количество детей',
                    fieldType: 'vautocomplete',
                    items: [0,1,2,3,4,5,6,7,8,9],
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    // Необязательно и ругается когда 0 детей
                    // rules: [
                    //     VR.required,
                    // ],
                },
                homePhone: {
                    value: '',
                    placeholder: 'Домашний телефон',
                    cleanValue() {
                        return CR.phone(this.value);
                    },
                    mask: '+7 ### ### ## ##',
                    type: 'tel',
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    // rules: [VR.required, VR.phone],
                },
                additionalPhone: {
                    value: '',
                    placeholder: 'Телефон контактного лица',
                    cleanValue() {
                        return CR.phone(this.value);
                    },
                    mask: '+7 ### ### ## ##',
                    type: 'tel',
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    rules: [
                        VR.required, 
                        VR.phoneFirstDigitIs9, 
                        VR.phone,
                        () => this.anketa.homePhone.value != this.anketa.additionalPhone.value || 'Номера телефонов должны быть разными'
                    ],
                },
                inn: {
                    value: '',
                    placeholder: 'ИНН',
                    mask: '##########',
                    rules: [
                        // VR.required, 
                        VR.inn
                    ],
                    grid: {
                        cols: 12,
                    },
                },
                education: {
                    placeholder: 'Образование',
                    fieldType: 'select',
                    rules: [VR.required],
                    list: [
                        { id:'1', text:'Неполное среднее'},
                        { id:'2', text:'Среднее'},
                        { id:'3', text:'Неполное высшее'},
                        { id:'4', text:'Высшее'},
                        { id:'5', text:'Ученая степень'},
                        { id:'6', text:'Два и более высших'},
                        { id:'7', text:'Среднее специальное'},
                    ],
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                },
                // job: {
                //     value: '',
                //     label: 'Трудоустройство',
                //     grid: {
                //         cols: 6
                //     }
                // },
                employmentType: {
                    value: '', // { value: 0, text: 'Выбрать' },
                    placeholder: 'Вид занятости',
                    fieldType: 'select',
                    list: [
                        {id:'1', text:'Рабочий'},
                        {id:'2', text:'Гос. служащий'},
                        {id:'3', text:'Коммерч. сотрудник'},
                        {id:'4', text:'Предприниматель'},
                        {id:'5', text:'Пенсионер'},
                        {id:'6', text:'Безработный'},
                        {id:'7', text:'Декретный отпуск'},
                        {id:'8', text:'Студент'},
                        // { value: 0, text: 'Выбрать' },
                        // { value: 1, text: 'Работаю в организации' },
                        // { value: 2, text: 'Собственный бизнес' },
                        // { value: 3, text: 'Фрилансер' },
                        // { value: 4, text: 'Студент' },
                        // { value: 5, text: 'Декрет' },
                        // { value: 6, text: 'Пенсионер' },
                        // { value: 7, text: 'Не работаю' },
                    ],
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    rules: [VR.requiredSelect],
                },
                position: {
                    value: '',
                    placeholder: 'Должность',
                    // isCyrilic: true,
                    visible: false,
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    rules: [VR.required],
                },
                workPhone: {
                    value: '',
                    placeholder: 'Рабочий телефон',
                    visible: false,
                    cleanValue() {
                        return CR.phone(this.value);
                    },
                    mask: '+7 ### ### ## ##',
                    type: 'tel',
                    grid: {
                        cols: 12,
                        md: 6,
                    },
                    rules: [VR.required, VR.phone],
                },
                
            },
        }
    }
}
